module.exports = __webpack_public_path__ + "static/media/data.96af9e3c.pdf";